/*
  Al elegir un mercado en el selector, cambia también al idioma de ese mercado.

  EL COMPORTAMIENTO QUE ARREGLA

  Shopify CONSERVA el idioma actual al cambiar de país. Comprobado enviando el formulario a
  mano: `country_code=IT` desde castellano redirige a `/es-it`, no a `/it-it`. Y no hay
  ajuste que lo cambie: si no se manda `language_code`, se queda el que hubiera.

  Con los cinco idiomas disponibles en los cinco mercados —que es lo que hace que el
  selector de idioma tenga sentido— eso significa que un visitante que elige Italia sigue
  leyendo en castellano. Aquí se rellena el idioma antes de que el formulario salga.

  POR QUÉ EN FASE DE CAPTURA

  El selector es un componente de Horizon: cada país lleva `on:click="/selectCountry/XX"`,
  y su manejador pone el país y envía el formulario en el mismo clic. Escuchando en la fase
  de captura —`{ capture: true }`, que corre ANTES de los manejadores del componente— hay
  tiempo de dejar el `<select>` de idioma en el valor correcto, y el envío ya se lo lleva.
  Sin la captura, el formulario sale con el idioma viejo.

  Así no hay que bifurcar `snippets/localization-form.liquid`, que es de Horizon: se queda
  idéntico al original y no genera conflicto en cada actualización del tema.

  El idioma no queda fijado. Una vez dentro del mercado, el selector de idioma sigue
  ofreciendo los cinco y el visitante manda.
*/
(function () {
  const nodo = document.getElementById('piriheno-mercado-idioma');
  if (!nodo) return;

  let porMercado;
  try {
    porMercado = JSON.parse(nodo.textContent);
  } catch {
    // Un JSON roto no debe romper el selector: sin mapa, se comporta como antes.
    return;
  }

  document.addEventListener(
    'click',
    (evento) => {
      const item = evento.target.closest('.localization-form__list-item[data-value]');
      if (!item) return;

      const pais = item.dataset.value;
      const idioma = porMercado[pais];
      if (!idioma) return;

      // El `<select>` de idioma y el país viven en el mismo formulario, así que basta con
      // dejarlo puesto: el envío del componente se lo lleva.
      const formulario = item.closest('form');
      if (!formulario) return;
      const select = formulario.querySelector('select[name="language_code"]');
      if (!select) return;

      // Solo si el mercado de destino ofrece ese idioma. Si no lo ofreciera, poner un
      // valor que no existe en el `<select>` lo dejaría vacío y el formulario iría sin
      // idioma, que es peor que no tocarlo.
      const existe = [...select.options].some((o) => o.value === idioma);
      if (!existe) return;

      select.value = idioma;
    },
    { capture: true },
  );
})();
